import { render, staticRenderFns } from "./VCandidateTasks.vue?vue&type=template&id=116d3da7&lang=pug"
import script from "./VCandidateTasks.vue?vue&type=script&lang=ts"
export * from "./VCandidateTasks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports